import type {
  EnvironmentProviders,
  ModuleWithProviders,
  Provider,
} from '@angular/core';
// eslint-disable-next-line local-rules/validate-freelancer-imports
import { FakeCollectionsWrapperTestingComponent } from '@freelancer/datastore/collections-testing/fake-collections-widget/testing/fake-collections-wrapper-testing.component';

// Using the real services in prod, nothing to replace.
export const fakeProviders: readonly (Provider | EnvironmentProviders)[] = [];

// Empty so DatastoreFakeModule never enters the release bundle.
export const fakeDatastoreModules: ModuleWithProviders<object>[] = [];

// Empty stand-in for `<fl-fake-collections>` so the fake datastore never enters the release bundle.
export const fakeCollectionsWrapper = FakeCollectionsWrapperTestingComponent;
